import { Outlet, useNavigate } from 'react-router-dom';
import React, { useState } from 'react'
import { Modal } from "react-bootstrap";
import DashboardSidebar from '../../layout/DashboardSidebar';
import { sidebarData } from './BdAccount_sidebar';

const BdAccountDashboard = () => {

    const [isexpand, setExpanded] = useState(false);


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const navigate = useNavigate();



    const [showttext, Setshowtext] = useState(false)

    const handleopen = () => Setshowtext(true);
    const handleclosetext = () => Setshowtext(false);

    return (
        <>
            <div className="dashboard-main-sectionbd">
                <DashboardSidebar sidebarData={sidebarData} isexpand={isexpand} setExpanded={setExpanded} />
                <div className={isexpand ? "dashboard-main-content-sectionn" : "dashboard-main-content-sectionnnbd"}>
                    <Outlet />
                </div>
            </div>
        </>
    );
};


export default BdAccountDashboard
